import { render, staticRenderFns } from "./ProtocolDialog.vue?vue&type=template&id=4fe94112&scoped=true"
import script from "./ProtocolDialog.vue?vue&type=script&lang=js"
export * from "./ProtocolDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe94112",
  null
  
)

export default component.exports